import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import SynopsisSection from './components/SynopsisSection';
import HomeNewsSection from './components/HomeNewsSection';
import RecommendSection from './components/RecommendSection';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar overlay />
      <main className="flex-1">
        <HeroBanner />
        <SynopsisSection />
        <HomeNewsSection />
        <RecommendSection />
      </main>
      <Footer />
    </div>
  );
}